import React, { useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import LoginPage, {notify_success, toastStyle} from './pages/LoginPage';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import type { MenuProps } from 'antd';
import { Breadcrumb, Dropdown, Layout, Menu, Space, theme } from 'antd';
import {DownOutlined, LogoutOutlined, SettingOutlined, TeamOutlined, UserOutlined} from '@ant-design/icons'
import { FaUsersViewfinder } from "react-icons/fa6"
import { MdAccountBalanceWallet, MdOutlineNotificationsActive } from "react-icons/md"
import { TbDeviceDesktopAnalytics } from "react-icons/tb"
import { PiBankBold } from "react-icons/pi"
import UsersPage from './pages/UsersPage'
import AdminUsersPage from './pages/AdminUsersPage'
import DashboardPage from './pages/DashboardPage'
import { ToastContainer} from 'react-toastify'
import { Store } from 'redux'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { selectAuthenticated, selectUserDetails, selectLoggedIn, selectAuthMessage } from './features/auth/authSlice'
import { useDispatch } from 'react-redux'
import { authorizeUser, logoutUser } from './features/auth/authAsyncThunk'
import BranchesPage from './pages/BranchesPage'
import ClientsPage from './pages/ClientsPage';
import NewClientPage from './pages/NewClientPage';
import LoansPage from './pages/LoansPage';
import NewLoanPage from './pages/NewLoanPage';
import LoanClearancePage from './pages/LoanClearancePage';
import TransactionsPage from './pages/TransactionsPage';
import NewSavingPage from './pages/NewSavingPage';
import SavingsPage from './pages/SavingsPage';
import { GrTransaction } from 'react-icons/gr';
import AccountsPage from './pages/AccountsPage';
import ExpendituresPage from './pages/ExpendituresPage';
import StatementPage from './pages/StatementPage';
import { getMetaData } from './actions/metaActions'
import CashinPage from './pages/CashinPage';
import InstitutionPage from './pages/InstitutionPage';
import MetadataPage from './pages/MetadataPage';
import LoanFinesPage from './pages/LoanFinesPage';
import NotificationsPage from './pages/NotificationsPage';
import LoanTopupPage from './pages/LoanTopupPage';
import LoanTopupsPage from './pages/LoanTopupsPage'
import { HiOutlineDocumentReport } from "react-icons/hi"
import ReportsPage from './pages/ReportsPage';
const { Header, Content, Footer, Sider } = Layout;

<ToastContainer
position="bottom-right"
autoClose={5000}
hideProgressBar
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="dark"
/>

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}
const items: MenuItem[] = [
  getItem('Dashboard', '1', <TbDeviceDesktopAnalytics />),
  getItem('Loans', '16', <PiBankBold />, [getItem('Loans', '17'),getItem('Register loan', '18'), getItem('Loan payments', '19'),getItem('Register topup', '26'),getItem('Topups', '27'), getItem('Loan fines', '22')]),
  getItem('Savings', '2', <MdAccountBalanceWallet />, [ getItem('New Saving', '5'), getItem('All Savings', '4')]),
  getItem('Transactions', '20', <GrTransaction />, [getItem('Expenses', '3'), getItem('Cash In', '25'), getItem('Cashbook', '9'), getItem('Statements', '21')] ),
  getItem('Clients', '6', <TeamOutlined />, [getItem('View All', '7'),getItem('New Client', '8'), getItem('Accounts', '11')]),
  getItem('Reports', '50', <HiOutlineDocumentReport />),
  getItem('Notifications', '40', <MdOutlineNotificationsActive /> ),
  getItem('Users', '0', <FaUsersViewfinder />, [getItem('Agents', '10')], ),
  getItem('Settings', '12', <SettingOutlined />, [ getItem('Branches', '13'), getItem('Meta data', '30')], ),

];

const agent_nav_items: MenuItem[] = [
  getItem('Loans', '16', <PiBankBold />, [getItem('Loans', '17'),getItem('Register loan', '18'), getItem('Loan payments', '19'), getItem('Register topup', '26'), getItem('Topups', '27'), getItem('Loan fines', '22')]),
  getItem('Savings', '2', <MdAccountBalanceWallet />, [ getItem('New Saving', '5'), getItem('All Savings', '4')]),
  getItem('Transactions', '20', <GrTransaction />, [getItem('Expenses', '3'), getItem('Cash In', '25'), getItem('Cashbook', '9'), getItem('Statements', '21')] ),
  getItem('Clients', '6', <TeamOutlined />, [getItem('View All', '7'), getItem('New Client', '8'), getItem('Accounts', '11')]),
];

interface AppProps{
  store: Store
}

const  App: React.FC<AppProps> = ({store})=> {
    const authenticated = useSelector(selectAuthenticated)
    const loggedIn = useSelector(selectLoggedIn)
    const loginMessage = useSelector(selectAuthMessage)
    const userDetails = useSelector(selectUserDetails)
    const [userRole, setUserRole]= useState<string>()
  
    const initialSelectedPage = userRole === 'admin' ? '1' : userRole === 'agent' ? '17' : undefined;
    const [selectedPage, setSelectedPage] = useState<string | undefined>(initialSelectedPage)

    const admin = userDetails?.role === 'admin'
    let final_items = admin ? items : agent_nav_items

    const dispatch = useDispatch()

       useEffect(() => {
        if (userDetails?.role) {
            setUserRole(userDetails.role)
        }
    }, [userDetails?.role])

    useEffect(() => {
        if (userRole) {
            setSelectedPage(userRole === 'admin' ? '1' : userRole === 'agent' ? '17' : undefined)
        }
    }, [userRole])
    
    useEffect(()=>{
      dispatch(authorizeUser() as any)
      dispatch(getMetaData() as any)
  }, [dispatch])

  const [collapsed, setCollapsed] = useState(false)
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleNavClick = (e: any) => {
    setSelectedPage(e.key);

  };

    const handleLogout = () => {
    dispatch(logoutUser() as any)
    notify_success(loginMessage, toastStyle)
    
  }

    const itemsNew = [
    { key: "1",label: "Profile", icon: <UserOutlined /> },
    { key: "2", danger: true,  label: "Logout", icon: <LogoutOutlined/>, onClick: handleLogout},
  ]

  return (
    
    <BrowserRouter>
    <ToastContainer position="top-center" className='text-capitalize small'/>
    {(loggedIn || authenticated) && ( <Layout style={{ minHeight: '100vh' }} hasSider>
      <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
        <div className="demo-logo-vertical">
          {/* <img src='/logo.png' style={logoStyles}></img> */}

        </div>
        <Menu   onClick={(e) => {
            handleNavClick(e);
          }} theme="dark" defaultSelectedKeys={[admin ? '1' : '17']} mode="inline" items={ final_items}/>
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: colorBgContainer }}>
        <Row style={{width: '100%'}}>
        <Col></Col>

        <Col className='d-flex justify-content-end px-2'>
        <Dropdown
          menu={{
            items:itemsNew,
          }}
        >
          
            <Space className='link-primary pre-auto'>
              <span>{userDetails?.other_names}</span>
              <span>{userDetails?.surname}</span>
              <DownOutlined />
            </Space>
          
        </Dropdown>
        </Col>
        </Row>
        </Header>
        <Content style={{ margin: '0 16px' }}>
          <Breadcrumb style={{ margin: '10px 0' }}>
            <Breadcrumb.Item>DLMS </Breadcrumb.Item>
          </Breadcrumb>
          <div style={{ padding: 24, minHeight: 360, background: colorBgContainer }}>
             <Routes>
              {(Number(selectedPage) === 1) &&  <Route path='/' element={<DashboardPage/>} />}
              {(Number(selectedPage) === 17) &&  <Route path='/' element={<LoansPage/>}></Route>}
              {(Number(selectedPage) === 4) && <Route path='/' element={<SavingsPage/>}/>}
              {(Number(selectedPage) === 2) && <Route path='/' element={<AdminUsersPage/>}/>}
              {(Number(selectedPage) === 5) && <Route path='/' element={<NewSavingPage/>}/>}
              {(Number(selectedPage) === 7) && <Route path='/' element={<ClientsPage/>}/>}
              {(Number(selectedPage) === 8) && <Route path='/' element={<NewClientPage/>}/>}
              {(Number(selectedPage) === 9) && <Route path='/' element={<TransactionsPage/>}/>}
              {(Number(selectedPage) === 10) && <Route path='/' element={<UsersPage/>} /> }
              {(Number(selectedPage) === 11) && <Route path='/' element={<AccountsPage/>} />}
              {(Number(selectedPage) === 13) && <Route path='/' element={<BranchesPage/>}/>}
              {(Number(selectedPage) === 14) && <Route path='/' element={<InstitutionPage/>}/>}
              {(Number(selectedPage) === 18) && <Route path='/' element={<NewLoanPage/>}/>}
              {(Number(selectedPage) === 19) && <Route path='/' element={<LoanClearancePage/>}/>}
              {(Number(selectedPage) === 21) && <Route path='/' element={<StatementPage/>}/>}
              {(Number(selectedPage) === 22) && <Route path='/' element={<LoanFinesPage/>}/>}
              {(Number(selectedPage) === 25) && <Route path='/' element={<CashinPage/>}/>}
              {(Number(selectedPage) === 26) && <Route path='/' element={<LoanTopupPage/>}/>}
              {(Number(selectedPage) === 27) && <Route path='/' element={<LoanTopupsPage/>}/>}
              {(Number(selectedPage) === 3) && <Route path='/' element={<ExpendituresPage/>}/>}
              {(Number(selectedPage) === 30) && <Route path='/' element={<MetadataPage/>}/>}
              {(Number(selectedPage) === 40) && <Route path='/' element={<NotificationsPage/>}/>}
              {(Number(selectedPage) === 50) && <Route path='/' element={<ReportsPage/>}/>}

            </Routes>
          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>DLMS v1.0 @{new Date().getFullYear()}</Footer>
      </Layout>
    </Layout>)}

    {(!loggedIn || !authenticated) && <LoginPage></LoginPage>}
    
   
    
    </BrowserRouter>
  );
}

export default App;
